import { format } from "date-fns";

export interface CrewCallsheetAssignmentRow {
  stream?: {
    date?: string;
    start?: string;
    end?: string;
  };
}

export interface CrewCallsheetResponse {
  results: CrewCallsheetAssignmentRow[];
}

export const streamDateYmd = (stream?: CrewCallsheetAssignmentRow["stream"]) => {
  if (!stream?.date) return null;
  return stream.date.length >= 10 ? stream.date.slice(0, 10) : stream.date;
};

export const isStreamScheduledToday = (stream?: CrewCallsheetAssignmentRow["stream"]) => {
  const today = format(new Date(), "yyyy-MM-dd");
  return streamDateYmd(stream) === today;
};

export const isStreamHappeningNow = (stream?: CrewCallsheetAssignmentRow["stream"]) => {
  if (!stream?.date || !stream.start || !stream.end) {
    return false;
  }

  const today = format(new Date(), "yyyy-MM-dd");
  const currentTime = format(new Date(), "HH:mm:ss");
  const start = stream.start.length === 5 ? `${stream.start}:00` : stream.start;
  const end = stream.end.length === 5 ? `${stream.end}:00` : stream.end;
  const streamDay = streamDateYmd(stream);

  return streamDay === today && start <= currentTime && currentTime <= end;
};

/** On Stream → Busy (any stream dated today) → Available (no callsheet for today). */
export const resolveStatusFromCallsheetResults = (
  results: CrewCallsheetAssignmentRow[],
): "On Stream" | "Busy" | "Available" => {
  if (results.some((row) => isStreamHappeningNow(row.stream))) {
    return "On Stream";
  }
  if (results.some((row) => isStreamScheduledToday(row.stream))) {
    return "Busy";
  }
  return "Available";
};
